import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["role", "aria-orientation"]

import { computed } from 'vue';
import type { RcSeparatorProps } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcSeparator',
  props: {
    decorative: { type: Boolean, default: true },
    orientation: { default: 'horizontal' }
  },
  setup(__props: any) {

const props = __props;

/**
 * Decorative separators are removed from the accessibility tree so that screen
 * readers skip over them. Meaningful separators keep the `separator` role and
 * expose their orientation.
 */
const role = computed(() => (props.decorative ? 'none' : 'separator'));

const ariaOrientation = computed(() => (props.decorative ? undefined : props.orientation));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("hr", {
    role: role.value,
    "aria-orientation": ariaOrientation.value,
    class: _normalizeClass({ vertical: props.orientation === 'vertical' })
  }, null, 10, _hoisted_1))
}
}

})